<template>
  <div>
    <v-row>
      <!-- <v-col sm="8" md="12">
        <s-toolbar label="Historial de Accesos" />
        <v-card>
          <v-col>
            <v-row>
              <v-col cols="6">
                <s-date label="Feha de inicio" v-model="begin"></s-date>
              </v-col>
              <v-col cols="6">
                <s-date label="Feha de fin" v-model="end"></s-date>
              </v-col>
              <v-col cols="6" class="s-col-form">
                  <s-toolbar-person noCamera label="Documento*" noEdit v-model="PrsDocumentNumber" @returnPerson="returnPerson($event, item)" />
              </v-col>
              <v-col cols="6" class="s-col-form">
                  <s-text readonly label="Persona" v-model="NtpFullName"></s-text>
              </v-col>
            </v-row>
            <v-row>
              <v-col><v-btn small color="primary" block @click="reporte()"> Generar Reporte</v-btn></v-col>
              <v-col><v-btn small :loading="loadData" color="teal lighten-1" block dark @click="reportModal()">{{ loadData ? '' : 'Visualizar Reporte' }}</v-btn></v-col>
            </v-row>
          </v-col>
        </v-card>
      </v-col> -->
      <v-col sm="12" md="12">
        <s-toolbar label="Historial de Accesos" searchInput @textSearch="textSearch($event)"/>
        <v-card>
          <v-col>
            <v-row>
              <v-col cols="2">
                <s-date label="Fecha de inicio" v-model="begin"></s-date>
              </v-col>
              <v-col cols="2">
                <s-date label="Fecha de fin" v-model="end"></s-date>
              </v-col>
              <v-col cols="2" >
                  <s-toolbar-person noCamera label="Documento*" noEdit v-model="PrsDocumentNumber" @returnPerson="returnPerson($event, item)" />
              </v-col>
              <v-col cols="2" >
                  <s-text readonly label="Persona" v-model="NtpFullName"></s-text>
              </v-col>
              <v-col cols="2" class="mt-4">
                <v-btn small color="teal lighten-1" dark block @click="reporte()"> Generar Reporte</v-btn>
              </v-col>
              <v-col cols="2" class="mt-4">
                <v-btn small :loading="loadData" color="primary" block dark @click="reportModal()">{{ loadData ? '' : 'Visualizar Reporte' }}</v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col>
            <v-data-table
                item-key="Line"
                dense
                fixed-header
                :items="items"
                :headers="headers"
                :items-per-page="10"
                v-model="selected"
            ></v-data-table>
          </v-col>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import _sAccessControl from "./../../services/Management/ControlAccess";
import sToolbarPerson from "@/components/Utils/Person/sToolbarPerson";
import SText from '../../components/Utils/SText.vue'
export default {
  name: "AccessControlReport",
  components: {sToolbarPerson, SText},
  props: {
    MltID: {
      type: Number,
      default: null,
    },
  },

  data: () => ({ pvs: "1", dialog: true, item: null, end: null, begin: null, PrsDocumentNumber: null, NtpFullName: null, items: [], headers: [], selected: [], loadData: false, Search: "" }),
  methods: {
    reporte() {
      _sAccessControl.historyaccess({ beginDate: this.begin, EndDate: this.end, NtpID: this.NtpID, Search: this.Search }).then((r) => {
        this.$fun.downloadFile(r.data, this.$const.TypeFile.EXCEL, "Reporte de Accesos");
      });
    },
    reportModal() {
      this.loadData = true;
      _sAccessControl.accesscontrolreport_excel({
        beginDate: this.begin,
        EndDate: this.end,
        NtpID: this.NtpID,
        Search: this.Search
      }).then((r) => {
        const data = r.data;

        if (Array.isArray(data) && data.length > 0) {
          // Generar headers dinámicamente
          this.headers = Object.keys(data[0]).map(key => ({
            text: key.replace(/_/g, ' ').toUpperCase(),
            value: key
          }));
        } else {
          this.headers = [];
        }

        this.items = data;
        this.loadData = false;
      });
    },
    returnObject(item) {
      this.item = item;
    },
    start() {
      if (this.item != null) this.$emit("start", this.item);
      else this.$fun.alert("Seleccione punto de Vigilancia", "warning");
      //  this.$router.push({ name: 'ACCESS_CONTROL_DETAIL', params: { pv: this.pvs } });
    },
    cancel() {
      this.$emit("cancel");
    },
    returnPerson(value, item) {
        if(value == null) return;
        this.NtpFullName = value.NtpFullName;
        this.PrsDocumentNumber = value.PrsDocumentNumber;
        this.NtpID = value.NtpID;
        this.PrsID = value.PrsID;
        this.WkrID = value.WkrID;
    },
    textSearch(text){
        this.Search = text;
        this.reportModal();
    },
  },
  mounted() {
    console.log(this.$route);
  },
};
</script>
